import { Injectable } from '@angular/core';

@Injectable()
export class SpinnerService
{
	private selector = 'loader-wrapper';
	private element: HTMLElement;

	constructor()
	{
		this.element = document.getElementById(this.selector);
	}

	public show(): void
	{
		this.element.style['display'] = 'block';

	}

	public hide(delay = 300): void
	{
		setTimeout(() =>
		{
			this.element.style['display'] = 'none';
		}, delay);
	}
}
